import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import youtubeLogo from '../assets/img/youtube-logo.svg';
import { Image } from 'react-bootstrap';
import ModalComponent from './ModalComponent';
import { VideoPreviewType } from '../utils/Types';

interface IVideoPlayerModalProps {
  isOpen: boolean;
  toggle: () => void;
  video: VideoPreviewType;
}

const VideoPlayerModal: React.FC<IVideoPlayerModalProps> = ({
  isOpen,
  toggle,
  video,
}) => {
  const [controlsVisible, setControlsVisible] = useState(false);
  const playerRef = useRef<ReactPlayer>(null);

  useEffect(() => {
    if (!isOpen && playerRef.current) {
      playerRef.current.getInternalPlayer()?.pause();
    }
  }, [isOpen]);

  const handleMouseEnter = () => setControlsVisible(true);
  const handleMouseLeave = () => setControlsVisible(false);

  return (
    <ModalComponent isOpen={isOpen} toggle={toggle} className="modalWrapper ">
      <button
        className="video-container button-container w-100"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <ReactPlayer
          ref={playerRef}
          url={video.url}
          controls={controlsVisible}
          width="100%"
          height="100%"
          style={{ background: '#000' }}
          pip={false}
          stopOnUnmount={true}
          light={video.thumbnail}
          playing
          playIcon={<Image src={youtubeLogo} alt="Play" />}
        />
        {controlsVisible && (
          <div className="overlay">
            <div className="video-name">{video.name}</div>
            <IconButton className="close-icon" onClick={toggle}>
              <CloseIcon />
            </IconButton>
          </div>
        )}
      </button>
    </ModalComponent>
  );
};

export default VideoPlayerModal;
